import type { CustomIntegrationConfigSchema } from "database/schema";
import {
  customIntegrationConfigSchema,
  integrations,
  integrationsConfigSchema,
} from "database/schema";
import { createInsertSchema } from "drizzle-zod";
import { z } from "zod";

export const createIntegrationSchema = createInsertSchema(integrations)
  .omit({
    business_id: true,
    config: true,
  })
  .extend({
    config: integrationsConfigSchema,
  });

export type CreateIntegrationSchema = z.infer<typeof createIntegrationSchema>;

export { customIntegrationConfigSchema, type CustomIntegrationConfigSchema };
